import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PermissionsService } from '@services/permissions.service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { UserInfo } from '@models/auth.model';
import { UserInfoComponent } from './user-info/user-info.component';
import { N15Component } from '@modules/user/pages/n15/n15.component';
import { NavbarService } from './navbar.service';
import { N08Service } from '@modules/user/pages/n08/n08.service';
import { StatisticsModel } from '@modules/user/pages/n08/n08.model';
import { NgxPermissionsService } from 'ngx-permissions';
import { BaseService } from '@services/base.service';
import { NotificationModel } from '@models/common.model';
import { environment } from 'src/environments/environment';

type SidebarNode = {
  name: string;
  link?: string;
  children?: SidebarNode[];
  roles?: Permissions[];
};

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  statistics: StatisticsModel;
  isNotification = false;
  listNotifications: NotificationModel[] = [];
  isOpenMenuNotifications: boolean = false;
  mapLevel = {
    'USER': 'Người dùng',
    'STORE': 'Store',
  };
  username: string;
  imgAvatar: string;
  constructor(
    private permissionService: PermissionsService,
    private dialog: MatDialog,
    private navbarService: NavbarService,
    private n08Service: N08Service,
    private baseService: BaseService,
    private permissionsService: NgxPermissionsService,
  ) {
  }

  Menu_User: SidebarNode[] = [
    { name: 'Home', link: '/user/n08' },
    {
      name: 'Quản lý ví và đại lý',
      children: [
        {
          name: 'Danh sách đại lý',
          link: '/user/n08/n082',
        },
        {
          name: 'Ví hoa hồng',
          link: '/user/n09/n091',
        },
        {
          name: 'Danh sách lịch sử tích lũy',
          link: '/user/n09/n093'
        },
        {
          name: 'Lịch sử trả thưởng',
          link: '/user/n09/n092'
        }
      ],
    },
    {
      name: 'Mua hàng',
      children: [
        {
          name: 'Danh mục SP chung',
          link: '/user/n13/n131',
        },
        {
          name: 'Danh mục SP STORE',
          link: '/user/n18/n181',
        },
        {
          name: 'Danh mục SP NBL',
          link: '/user/n18/n183',
        },
        {
          name: 'Danh mục SP KHTT',
          link: '/user/n18/n182',
        },
        {
          name: 'Danh mục SP săn quà',
          link: '/user/n14',
        },
        {
          name: 'Danh mục SP ưu đãi giờ vàng',
          link: '/user/n21',
        },
        {
          name: 'Danh mục SP nutrishop',
          link: '/user/n13/n132',
        },
        {
          name: 'Danh mục SP năng động',
          link: '/user/n18/n184',
        },
        {
          name: 'Danh mục SP kích hoạt user',
          link: '/user/n18/n185',
        },
        {
          name: 'Danh mục SP kích hoạt shop',
          link: '/user/n18/n186',
        },
      ],
    },
    { name: 'Danh sách đơn hàng', link: '/user/n11' },
  ];

  ngOnInit(): void {
    if (!(this.permissionsService.getPermission('ADMIN') || 
      this.permissionsService.getPermission('ACCOUNTANT') ||
      this.permissionsService.getPermission('SALE_1') ||
      this.permissionsService.getPermission('SALE_2')
      )) {
      this.n08Service.getStatistic().subscribe({
        next: response => {
          this.statistics = response?.data;
        }
      })
    }
    if (this.permissionsService.getPermission('ADMIN')) {
      this.baseService.getNotification().subscribe({
        next: response => {
          this.listNotifications = response.data.items;
          this.isNotification = response.data.items.some(item => !item.read)
          if (this.isOpenMenuNotifications) {
            this.onShowNotifications();
          }
        }
      });
      setInterval(() => {
        this.baseService.getNotification().subscribe({
          next: response => {
            this.listNotifications = response.data.items;
            this.isNotification = response.data.items.some(item => !item.read)
            if (this.isOpenMenuNotifications) {
              this.onShowNotifications();
            }
          }
        });
      }, environment.timeInterval);
    }

    this.permissionService.userInfo.subscribe({
      next: userInfo => {
        this.username = userInfo.username;
        this.navbarService.imgAvatar.next(userInfo['avatar']);
      }
    })
    this.navbarService.imgAvatar.subscribe({
      next: img => {
        this.imgAvatar = img;
      }
    })
  }

  openUserInfo() {
    this.dialog.open(UserInfoComponent, {
      width: "auto"
    });
  }

  onOpenModal() {
    const dialogRef = this.dialog.open(N15Component, {
      data: this.username,
    });
  }

  onOpenChangePass() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {

    });
  }
  isOpen?: boolean = true;
  toggleSidenav() {
    this.isOpen = !this.isOpen;
    this.navbarService.isOpen.next(this.isOpen);
  }
  logout() {
    this.permissionService.logout();
  }

  onShowNotifications() {
    this.isOpenMenuNotifications = true;
    this.baseService.getListNotifications().subscribe({
      next: response => {
        this.isNotification = false;
      }
    });
  }
}
